import { render, staticRenderFns } from "./SupplierOverdueNumberDisplayer.vue?vue&type=template&id=4da9869f"
import script from "./SupplierOverdueNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SupplierOverdueNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports